export default __webpack_public_path__ + "static/media/texPokemonsShiny.eb84ca26.jpg";